import { styles } from './styles';
import * as colors from './styles/colors';
export const config = {
    colors,
    styles,
    radii: '4px',
    mode: 'light',
    showPlaygroundEditor: false,
    inPageSearch: false,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbmZpZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sVUFBVSxDQUFBO0FBQ2pDLE9BQU8sS0FBSyxNQUFNLE1BQU0saUJBQWlCLENBQUE7QUFFekMsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHO0lBQ3BCLE1BQU07SUFDTixNQUFNO0lBQ04sS0FBSyxFQUFFLEtBQUs7SUFDWixJQUFJLEVBQUUsT0FBTztJQUNiLG9CQUFvQixFQUFFLEtBQUs7SUFDM0IsWUFBWSxFQUFFLEtBQUs7Q0FDcEIsQ0FBQSJ9